const Titles = {
    "WELLCOME_TO_THE" : "Welcome to the",
    "LOGIN" : "Login",
    "PASSWORD" : "Password",
    "DON'T_REMEMBER_PASSWORD" : "Don`t remember password",
    "ENTER": "Enter",
    "REQUEST": "Leave a request",
    "SIGN_IN" : "Sign in",
    "EMAIL_OR_LOGIN" : "Email or Login",
    "CONTINUE" : "Contimnue",
    "ABOUT_PRODUCT": "About the product",
    "SITUABLE_FOR": "For whom",
    "HOW_WORKS": "How it works",
    "ADVANTAGES": "Benefits",
    "CONTACTS": "Contacts",
    "TELEGRAM": "Telegram",
    "LANGUAGES": "Languages",
    "INFO_SOURCE": "Sources of information",
    "MEDIA_COUNT": "Number of media outlets",
    "KZ_COUNT": "Including Kazakhstani",
    "SOCIAL_COUNT": "Accounts in social networks",
    "GET_MORE": "Learn more",
    "NAME": "Name",
    "PHONE": "Phone number",
    "FIELD_NOT_BE_EMPTY": "Field not be empty",
    "PASSWORD_RESTORE" : "Restore password",
    "ONLY_NUMBERS_AND_LETTERS_AT_LEAST_3": "Only letters and numbers, at least 3 symbols",
    "ONLY_NUMBERS_AND_LETTERS": "Only letters and numbers",
    "ONLY_LETTERS": "Only letters",
    "A_LETTER_WITH_INSTRUCTIONS_WAS_SENT_TO_YOUR_EMAIL_ADDRESS" : "НА ВАШ АДРЕС ЭЛЕКТРОННОЙ ПОЧТЫ БЫЛО ОТПРАВЛЕНО ПИСЬМО С ИНСТРУКЦИЕЙ",
    "SORRY_SUCH_MAIL_OR_LOGIN_IS_NOT_REGISTERED" : "К СОЖАЛЕНИЮ, ТАКАЯ ПОЧТА ИЛИ ЛОГИН НЕ ЗАРЕГИСТРИРОВАНЫ",
    "TRY_AGAIN" : "Try again",
    "CANCEL" : "Cancel",
    "OBLIGATORY_FIELD": "Required field",
    "ONLY_NUMBER": "Phone number entered incorrectly",
    "TOPICS_FOR_MONITORING": "Topics for monitoring (key words)",
    "DEMONSTRATION_PRODUCT": "Demonstration product",
    "GET_DEMO_LICENSE": "By clicking ‘Send’, you agree to ",
    "GET_DEMO_LICENSE_POLICY": " the Privacy Policy ",
    "GET_DEMO_LICENSE_2": "on the processing of personal data",
    "GET_DEMO_SUCCESS": "The request for demo access has been sent successfully.",
    "EMAIL_ADDRESS" : "Your email (format: login@example.com)",
    "NOT_VALID_EMAIL" : "NOT VALID EMAIL ADDRESS",
    "NEW_REVIEW_ON_MAP": "New review on the online map",
    "GOOD_SERVICE": "Good service, I recommend",
    "YOU_WERE_MENTIONED_IN_COMMENT": "You were mentioned in a comment",
    "USER_MENTIONED_YOU": "User @karina8800 mentioned you in a comment",
    "YOU_MENTIONED_ON_MEDIA": "YOU WERE MENTIONED IN 1 MEDIA",

    "CLOSE": "Close",
    "MONITORING": "Monitor",
    "MEDIA_SOCIAL_BLOGS": "media, social networks, blogs,",
    "REVIEWS_ON": "reviews ",
    "ONLINE_MAPS": " in online maps",
    "TRACK_MEMORIES": "Track mentions, analyse trends, predict risks!",
    "MONITORING_FAVOURITVE_SOCIAL": "Monitoring of popular social networks and media (including 5000 Kazakhstani ones), as well as reviews in online maps ",
    "GET_DEMO_ACCESS": "Get demo access",
    "WANT_DEMO_ACCESS": "Want demo-access",
    "KEYWORDS": "Key words",
    "TOPICS_AND_KEYWORDS": "Topics and keywords",
    "KEYWORDS_DESCRIPTION": "The system automatically collects publications that contain at least one of the specified keywords in the text or in the title",
    "KEYWORDS_TEXT": "<ul><li>You specify keywords - they can be terms, phrases or word combinations.</li><li>All information is structured in a convenient ribbon, which makes it easy to analyse and track the necessary mentions.</li></ul>Flexible customisation allows you to quickly find relevant data and effectively manage information flows.",

    "BIG_DATA": "Big Data",
    "MEDIA": "MEDIA",
    "REVIEWS_FROM_MAPS": "Testimonials",
    "SOCIAL": "Social Networks",
    "MENTIONS": "Mentions",
    "KEY_WORDS": "Keywords",

    "BE_FIRST_TO_KNOW": "Be the first",
    "WHO_WROTE_ABOUT": " to know who wrote about you in media publications and social media posts",
    "MONITOR_THE_REPUTATION": "Monitor the reputation",
    "COMPANIES_BRANDS_TOP_MANAGMENT": " of your company, brand or top manager in any information field:",
    "MEDIA_SOCIAL_TELEGRAM": " media, social networks, Telegram channels and online reviews in online maps",
    "GET_VALUABLE_INSIGHTS_BOLD": "Get",
    "GET_VALUABLE_INSIGHTS": " valuable insights",
    "IN_REALTIME": " in real time about your partners, customers or competitors directly to Telegram or email",

    "A_TOOL_FOR_STRATEGIC": " A tool for strategic management in politics, business, media and science. Allows you to proactively identify risks and opportunities, monitor reputation, track competitors and manage information flows for effective PR campaigns.",

    "TOPIC_COMPARISON": "Topic comparison",
    "TOPIC_COMPARISON_DESCRIPTION": "The system allows you to compare different information flows, identify patterns and analyse changes in mentions.",
    "TOPIC_COMPARISON_TEXT": "<ul><li>Select several topics for comparison.</li> <li>The system analyses them according to key metrics: number of mentions, tone, distribution dynamics.</li> <li>Data visualisation helps to identify trends, determine which topics are gaining popularity and which are losing relevance.</li> <li>Compare competitors' activities to solve PR tasks.Flexible customisation allows you to quickly find relevant data and effectively manage information flows</li></ul>This tool allows you to quickly assess the impact of news events and adjust response strategies.",

    "SAMPLE": "Selection",
    "SAMPLE_DESCRIPTION": "The system helps you quickly find relevant publications in a convenient feed with flexible filters and sorting options.",
    "SAMPLE_TEXT": "<ul><li>Use advanced filters by time, sources, sentiment, and keywords.</li> <li>The system instantly generates a list of mentions that match the specified criteria.</li> <li>Focus only on up‑to‑date information, avoiding information noise.</li> </ul>This tool enables rapid data analysis, trend tracking, and well‑informed decision‑making.",

    "EXTENDED_ANALYTIC": "Advanced analytics",
    "EXTENDED_ANALYTIC_DESCRIPTION": "The system provides interactive dashboards to explore the information field in detail.",
    "EXTENDED_ANALYTIC_TEXT": "<ul><li>Analyse data with flexible filters by time, source, tone and key metrics.</li><li>Track trend dynamics and audience insights.</li><li>Visualise data in an easy-to-use format to help you quickly find patterns and make informed decisions</li></ul> This tool allows you to gain valuable insights, predict changes and adjust strategies in real time.",

    "REPORTS": "Reports",
    "REPORTS_DESCRIPTION": "The system allows you to quickly generate detailed analytical summaries in a few clicks.",
    "REPORTS_TEXT": "<ul><li>Generate reports by selected parameters for in-depth analytics.</li> <li>Export data in a convenient format (PDF, Excel, Word, JSON).</li> <li>Set up automatic sending of reports to stakeholders.</li></ul> This tool simplifies the work with data, helping you to quickly share analytics and make strategic decisions",
    
    "DASHBOARDS": "Dashboards",
    "DASHBOARDS_DESCRIPTION": "The system allows you to quickly assess the situation by providing concise and informative metrics.",
    "DASHBOARDS_TEXT": "<ul><li>All key information is presented on one page.</li> <li>Track key metrics and trends without the need for in-depth analysis.</li> <li>Get quick insights for rapid decision-making.</li></ul> This tool helps you instantly assess the dynamics of events and react quickly to changes",

    "NOTIFICATIONS": "Notifications",
    "NOTIFICATIONS_DESCRIPTION": "The system allows you to receive instant notifications about significant changes in the media field.",
    "NOTIFICATIONS_TEXT": "<ul><li>Receive notifications in Telegram and email.</li><li>Track new publications, trends and important changes in real time.</li> <li>React quickly to control the situation and minimise risks.</li></ul>  This tool helps you stay ahead of the curve and quickly make informed decisions",
    
    "MEDIAMONITORING": "media monitoring",
    "IN_ONLINE": "in real-time",
    "MEDIAMONITORING_DESCRIPTION_TEXT": "A complete overview of the information field: analysing publications, trends and reviews",
    "SOCIAL_MONITORING": "Media monitoring, social networks, reviews on maps",
    "LIVE_TRACKING": "Real-time tracking of news and mentions in real time",
    "REPUTATION_ANALYSIS": "Reputational risk analysis of companies, executives and industries",
    "HISTORICAL_ANALYSIS": "Historical analysis and long-term trends",
    "CONTENT_ANALYSIS": "Content analysis in Kazakh",
    "WRITERS_RATING": "Ranking of influential media and authors writing about you with tone analysis",

    "CONVENIENT_FILTERING": "Easy filtering by specified parameters",
    "NOTIFICATIONS_ONLNE": "Real-time notifications",
    "STRUCTURED_SELECTION": "Structured news collection",
    "EXPORT_PUBLICATIONS": "Export collected publications",
    "USERS_NUMBER": "Unlimited number of users in your office",
    "INTERCATIVE_DASHBOARDS": "Interactive dashboards and reports",
    "SAVING_FILTERS": "Save filters and settings",

    "CONVENIENT_FILTERING_TEXT": "Intuitive filters make it easy to find the information you need and create a selection.",
    "NOTIFICATIONS_ONLNE_TEXT": "Receive alerts on positive and negative mentions in Telegram and email. Respond quickly, mitigate reputational risks and build brand trust.",
    "ANALYTIC_TEXT": "Evaluate the scale and dynamics of mentions, identify trends, analyse the tone of publications and predict the development of reputational topics.",
    "STRUCTURED_SELECTION_TEXT": "The system automatically collects and organises the latest news by keywords and topics, providing quick access to the publications you need.",
    "EXPORT_PUBLICATIONS_TEXT": "Flexible export settings simplify your work - upload reports to PDF, Word, Excel or JSON in just a few clicks.",
    "USERS_NUMBER_TEXT": "Connect an unlimited number of users to your account and manage access without unnecessary restrictions.",
    "INTERCATIVE_DASHBOARDS_TEXT": "Visual analytics and visual reports make it easy to analyse your data and get key insights quickly.",
    "SAVING_FILTERS_TEXT": "The system allows you to save filters for reusable theme settings",
    "ASK": "Ask",
    "EXPERT": "the Expert",
    "HAS_QUESTIONS": "Do you have any questions? Ask our experts",
    "SCOPE_ACTIVITY": "Area of expertise",
    "TELEPHONE": "Phone number",
    "YOUR_QUESTION": "Your question",
    "ON_PRESSING_SUBMIT": "By clicking ‘Send’, you agree to",
    "PRIVACY_POLICY_2": "Privacy policy",
    "PRIVACY_POLICY": "the Privacy Policy",
    "PROCESSING_PERSONAL_DATA": "on the processing of personal data",
    "SUBMIT": "Submit",
    "RETURN": "Return",
    "SEND_MESSAGE_SUCCESS": "Your message has been sent successfully.",
    "OUR_PARTNERS": "Our partners",

    "GOVERNMENT_BODIES": "Public Bodies:",
    "GOVERNMENT_BODIES_DESCRIPTION": " Government, Akimats, Committees, Departments, Services",
    "GOVERNMENT_BODIES_TEXT": "Monitor public opinion and control information flows. Evaluate public reaction and the effectiveness of government initiatives in real time",
    
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS": "Political and public organizations:",
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS_DESCRIPTION": "Parties, NGOs, Public Associations",
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS_TEXT": " Analyse the effectiveness of campaigns and combat misinformation. Assess the impact of political and social initiatives, track down fakes and protect reputations.",

    "BUSINESS_AND_FINANCE": "Business and finance:",
    "BUSINESS_AND_FINANCE_DESCRIPTION": "Companies, banks and financial institutions",
    "BUSINESS_AND_FINANCE_TEXT": "Reputation control and market analysis. Forecast risks, identify insights and track key market trends.",

    "QUASI_PUBLIC_AND_PRIVATE_SECTOR": "Quasi-public and Private Sector:",
    "QUASI_PUBLIC_AND_PRIVATE_SECTOR_DESCRIPTION": "Companies, Large Enterprises, Private Institutions ",
    "QUASI_PUBLIC_AND_PRIVATE_SECTOR_TEXT": "Reputation management and competitive analysis. Analyse the market, track mentions and build an effective PR strategy.",

    "MEDIA_ANALYTICS_AND_PR": "Media, analytics and PR:",
    "MEDIA_ANALYTICS_AND_PR_DESCRIPTION": "Media, PR agencies, research institutes, think tanks",
    "MEDIA_ANALYTICS_AND_PR_TEXT": "Deep analytics and trend identification. Analyze information flows, track key topics and generate insights for effective strategies.",
    "OFFERT": "Offert",
    "TELEGRAM_BOT": "Telegram-bot",
    "FCBK": "First Credit Bureau LLP",
    "RUS" : "Русский",
    "KAZ" : "Қазақ",
    "ENG" : "English",
};

export default Titles;